import React from 'react';
import { motion } from 'framer-motion';

const WhatsAppButton = ({ whatsappNumber }) => {
  const cleanNumber = whatsappNumber ? whatsappNumber.replace(/\D/g, '') : null;
  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    if (!cleanNumber) return;
    const message = "Hola, me gustaría recibir más información sobre sus productos.";
    const url = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(url, '_blank');
  };
  if (!cleanNumber) return null;

  return (
    <motion.button
      onClick={handleWhatsAppClick}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.1, y: -5 }}
      whileTap={{ scale: 0.9 }}
      className="fixed bottom-8 right-8 z-[100] group flex items-center gap-3 cursor-pointer outline-none border-none bg-transparent"
    >
      <span className="bg-white/40 backdrop-blur-xl border border-gray-200 px-4 py-2 rounded-2xl text-[10px] font-black uppercase tracking-widest text-slate-600 opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none shadow-xl italic">
        Chat en línea
      </span>

      <div className="relative">
        <div className="absolute inset-0 bg-[#a6192e] rounded-full blur-xl opacity-20 group-hover:opacity-40 animate-pulse transition-opacity"></div>
        
        <div className="relative w-16 h-16 bg-white/80 backdrop-blur-2xl border border-gray-100 rounded-full flex items-center justify-center shadow-2xl group-hover:border-[#a6192e]/30 transition-all overflow-hidden">

          <div className="absolute inset-0 bg-[#a6192e] translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out"></div>
        
          <svg 
            className="w-8 h-8 relative z-10 text-[#a6192e] group-hover:text-white transition-colors duration-300" 
            fill="currentColor" 
            viewBox="0 0 24 24"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.148-.67-1.614-.917-2.214-.242-.584-.487-.504-.67-.514-.173-.009-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          </svg>
        </div>
      </div>
    </motion.button>
  );
};

export default WhatsAppButton;